import * as Actions from 'reducks/storeCalendar/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const StoreCalendarReducer = (state = initialState.storeCalendar, action: any) => {
  switch (action.type) {
    case Actions.SET_STORE_CURRENT_MONTH:
      return {
        ...state,
        currentMonth: action.payload,
      }
    case Actions.SET_CLOSED_STORE_CALENDARS:
      return {
        ...state,
        closedStoreCalendars: [...action.payload],
      }
    case Actions.SET_ORDERED_STORE_CALENDARS:
      return {
        ...state,
        orderedStoreCalendars: [...action.payload],
      }
    case Actions.SET_STORE_CALENDARS:
      return {
        ...state,
        storeCalendars: [...action.payload],
      }
    case Actions.INIT_STORE_CALENDAR:
      return {
        ...initialState.storeCalendar,
      }
    default:
      return state
  }
}
